import { Injectable } from '@angular/core';
import parsePhoneNumber, { CountryCode, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';

@Injectable({
  providedIn: 'root',
})
export class ParsePhoneNumberService {
  phoneDataByCountryCode(countryCode: CountryCode): { mask: string; code: string; placeholder } {
    const exampleData = getExampleNumber(countryCode, examples);
    const examplePhoneOfCounty = exampleData.number;
    const code = exampleData.countryCallingCode.toString();
    const phoneNumber = parsePhoneNumber(examplePhoneOfCounty.toString());
    const placeholder = phoneNumber.formatInternational().replace(`+${code} `, '');
    const mask = placeholder.replace(/\d/g, '0');
    return { mask, code, placeholder };
  }

  getMaskByPhoneNumber(phoneNumber: string): string {
    const parsedData = parsePhoneNumber('+' + phoneNumber).formatInternational();
    return parsedData.replace(/\d/g, '0');
  }

  phoneSplitter(phoneNumber: string): { phone: string; mask: string; country: CountryCode } {
    try {
      let formattedNumber = phoneNumber;
      switch (phoneNumber[0]) {
        case '8':
          formattedNumber = phoneNumber.replace('8', '7');
          break;
        case '+':
          formattedNumber = phoneNumber.replace('+', '');
          break;
      }
      const data = parsePhoneNumber('+' + formattedNumber);
      return {
        phone: String(data.nationalNumber),
        mask: String(data.countryCallingCode),
        country: data.country,
      };
    } catch (e) {
      console.error('Не удалось расспарсить номер ' + phoneNumber, e);
      return { phone: null, mask: '7', country: 'KZ' };
    }
  }

  validator(phoneNumber, countryCode: CountryCode): boolean {
    const parsedPhone = parsePhoneNumber(phoneNumber);
    return parsedPhone && parsedPhone.country === countryCode;
  }
}
